import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <div class="middle-content">
            <ng-transclude></ng-transclude>
        </div>
        <style>
            learn-modal-topbar-middle-content {
                display: contents;
            }

            .middle-content {
                display: flex;
                align-items: baseline;
                width: 100%;
                place-content: center;
                padding: 0 30px 0 20px;
            }

            .container.active .topbar .middle-content h1 {
                display: none;
            }

            .container.active .topbar .middle-content .progress-wrapper {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
            }

            @media (min-width: 768px) {

            .container.active .topbar .middle-content h1 {
                    display: flex;
            }

                .middle-content {
                    justify-content: space-between;
                }
            }
        </style>
    `
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/learnModal/topbar/middleContent/index.js